import { Theme } from '@material-ui/core'
import createStyles from '@material-ui/styles/createStyles'
import makeStylesWrapper from 'core/helpers/styles'

const style = (theme: Theme) => {
  return createStyles({
    box: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      alignSelf: 'flex-start',
      marginTop: theme.spacing(1),
    },
    icon: {
      marginRight: theme.spacing(0.5),
    },
  })
}

export default makeStylesWrapper(style)
